/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketquantitybelowsolderror4Inputs */

const en_ticketquantitybelowsolderror4 = /** @type {(inputs: Ticketquantitybelowsolderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More tickets are already taken than the seats you entered.`)
};

const de_ticketquantitybelowsolderror4 = /** @type {(inputs: Ticketquantitybelowsolderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind schon mehr Tickets vergeben, als Plätze angegeben sind.`)
};

/**
* | output |
* | --- |
* | "More tickets are already taken than the seats you entered." |
*
* @param {Ticketquantitybelowsolderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketquantitybelowsolderror4 = /** @type {((inputs?: Ticketquantitybelowsolderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketquantitybelowsolderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketquantitybelowsolderror4(inputs)
	return de_ticketquantitybelowsolderror4(inputs)
});
export { ticketquantitybelowsolderror4 as "ticketQuantityBelowSoldError" }